<template>
<div>
    <b-tabs>
    <b-tab lazy title="Recientes">
      <Recientes />
    </b-tab>
    <b-tab lazy title="Todas">
      <Listar />
    </b-tab>
    <b-tab lazy title="Busqueda">
      <Busqueda />
    </b-tab>
  </b-tabs>
  <b-row>
    <b-col>
      <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" @click="agregar">
        Añadir al Menu
      </b-button>
    </b-col>
  </b-row>

</div>
  
</template>
<script>


import {
  BTabs,
  BTab,
  BButton,
  BRow,
  BCol,
} from "bootstrap-vue";
import Recientes from "@/views/apariencia/enlaces/enlaces/tabs/Recientes.vue";
import Listar from "@/views/apariencia/enlaces/enlaces/tabs/Listar.vue";
import Busqueda from "@/views/apariencia/enlaces/enlaces/tabs/Busqueda.vue";

import Ripple from "vue-ripple-directive";



export default {
  components: {

    BRow,
    BCol,
    BTabs,
    BTab,
    BButton,

    Recientes,
    Listar,
    Busqueda,
  },
  directives: {
    Ripple,
  },
  computed: {
    elementsEnlaces(){
      return this.$store.state.enlaces.enlaces_elementos;
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
        agregar() {
      this.elementsEnlaces.forEach((item)=>{
        const d = new Date();
        let time = d.getTime();
        var idtime=item.id+"-"+time;
        
        var itemadd = {
        menuitemable_id: item.id,
        time: idtime,
        tipo: "enlace",
        etiqueta: item.nombre,
        titulo: item.nombre,
        icono:item.icono,
      };
      this.$store.dispatch("enlaces/addElements", itemadd);
      });
      this.$store.dispatch("enlaces/updateElementsEnlaces", []);
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>